"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
exports.default = (0, react_intl_1.defineMessages)({
    backTo: {
        id: 'common.back_to',
        defaultMessage: 'Back to {origin}',
    },
    delete: {
        id: 'common.delete',
        defaultMessage: 'Delete',
    },
    cancel: {
        id: 'common.cancel',
        defaultMessage: 'Cancel',
    },
    refresh: {
        id: 'common.refresh',
        defaultMessage: 'Refresh',
    },
});
//# sourceMappingURL=common.js.map